import SvgIcon from '@home/components/SvgIcon';
import React, { useRef, useState } from 'react';
import { Bubble, Button, Modal } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';
import { SentimentType } from '@op/types/common';
import { sentimentIconMap } from '@op/constants';
import classnames from 'classnames';
import { DBO_T } from '@op/utils/format';
import DOMPurify from 'dompurify';

export default function useFullDialog({
  renderHtml: hookRenderHtml,
  summary: hookSummary,
  fullTitle: hookFullTitle,
  hideSubTitle: hookHideSubTitle,
  className: hookClassName,
}: {
  renderHtml?: any;
  summary?: string;
  fullTitle?: string;
  hideSubTitle?: boolean;
  className?: string;
}) {
  const { formatMessage } = useIntl();
  const [visible, setVisible] = useState(false);
  const htmlRef = useRef<HTMLDivElement>(null);

  const openFullDialog = () => {
    setVisible(true);
  };
  function FullDialog({
    GPTSentiment,
    renderHtml = hookRenderHtml,
    summary = hookSummary,
    fullTitle = hookFullTitle,
    hideSubTitle = hookHideSubTitle,
    className = hookClassName,
  }: {
    GPTSentiment?: SentimentType;
    renderHtml?: any;
    summary?: string;
    fullTitle?: string;
    hideSubTitle?: boolean;
    className?: string;
  }) {
    if (!visible) return null;
    return (
      <Modal
        className={classnames('dbo-gpt-summary-modalbox', className)}
        visible={visible}
        size={800}
        caption={
          <>
            <div className="dbo-gpt-summary-modal-title">
              {fullTitle ? fullTitle : formatMessage({ id: 'AI Summary' })}
              <Bubble
                closeOnScroll
                dark
                content={formatMessage({ id: 'Copy text' })}
              >
                <div
                  className="dbo-gpt-summary-modal-icon"
                  onClick={() =>
                    void DBO_T.copy(htmlRef.current, formatMessage)
                  }
                >
                  <SvgIcon
                    type="datalab-copy"
                    className="dbo-gpt-summary-modal-icons"
                  />
                </div>
              </Bubble>
            </div>
            {!hideSubTitle && (
              <div className="dbo-gpt-summary-modal-tips">
                {formatMessage({
                  id: 'The large model selects valid reviews to summarize opinions, which may not cover all reviews.',
                })}
              </div>
            )}
          </>
        }
        onClose={() => {
          setVisible(false);
        }}
      >
        <Modal.Body>
          <div className="dbo-gpt-summary-modal">
            {GPTSentiment && (
              <SvgIcon
                type={sentimentIconMap[GPTSentiment]}
                className="dbo-aigc-sentiment-icon"
              />
            )}
            <span
              ref={htmlRef}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(renderHtml as string),
              }}
            ></span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type="primary" onClick={() => setVisible(false)}>
            {formatMessage({ id: 'Close' })}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return {
    FullDialog,
    openFullDialog,
    setVisible,
  };
}
